import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MessageList from '../components/chat/MessageList';
import { FaArrowLeft } from 'react-icons/fa';

const ConversationDetailPage: React.FC = () => {
  const { t } = useTranslation();
  const { conversationId } = useParams<{ conversationId: string }>();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/conversations');
  };

  return (
    <div className="flex flex-col h-full">
      {/* Header with back button */}
      <div className="fixed top-16 left-0 right-0 bg-base-200 border-b border-base-300 z-30">
        <div className="flex items-center px-4 py-3">
          <button
            onClick={handleBack}
            className="btn btn-ghost btn-sm gap-2"
          >
            <FaArrowLeft />
            <span className="hidden sm:inline">{t('common.back')}</span>
          </button>
          <h2 className="text-lg font-semibold ml-2">{t('conversations.conversation')}</h2>
        </div>
      </div>

      {/* Message list with appropriate padding */}
      <div className="pt-28 pb-20 h-full">
        <MessageList conversationId={conversationId ? parseInt(conversationId, 10) : undefined} />
      </div>
    </div>
  );
};

export default ConversationDetailPage;
